import { css } from 'styled-components';

export default css`
  .new-dashboard {
    --app-bg: var(--royalBlue);
    --alert-type-color-1: #7f55d9;
    --alert-type-color-2: #9f78ed;
    --alert-type-color-3: #b594f5;
    --alert-type-color-4: #d6bafc;
    --alert-type-color-5: #e9d8fd;
    --alert-type-color-6: var(--languidLavender);
    --dashboard-box-radius: var(--main-border-radius);
    --dashboard-box-bg: var(--nav-menu-bg);
    --dashboard-main-font-color: var(--darkMode-white);
    --dashboard-secondary-font-color: var(--zeroGrey);
    --dashboard-text-transform: uppercase;
    --dashboard-seperator-border: var(--white-100);
    --dashboard-chip-bg: var(--white-100);
    --dashboard-chip-color: var(--darkMode-white);
    --dashboard-rechart-background: var(--nav-menu-bg);
    --dashboard-active-chart-tick: rgb(150, 170, 171);
    --dashboard-inactive-chart-tick: var(--zeroGrey);
    --dashboard-legend-text: var(--darkMode-white);
    --dashboard-empty-legend-color: var(--darkMode-white);
    --dashboard-legend-item-wrapper: var(--darkMode-white);
    --dashboard-linkable-title: var(--main-green);
    --dashboard-linkable-title-hover: var(--main-green);
    --dashboard-news-item-sub-header: var(--zeroGrey);
    --dashboard-background: var(--mainBgColor);
    --dashboard-items-container: var(--nav-menu-bg);
    --dashboard-active-alert-item-radius: 10px;
    --dashboard-main-section-header-bg: var(--nav-menu-bg);
    --dashboard-trend-text-empty: var(--zeroGrey);
    --dashboard-trend-text: var(--white);
    --dashboard-last-discovery: var(white-600);
    --dashboard-date-time-number: var(--darkMode-white);
    --dashboard-date-time-letter: var(--zeroGrey);
    --dashboard-date-time-font-size: 12px;
    --dashboard-trend-text-secondary-color: var(--zeroGrey);
    --dashboard-trend-bad-color: #ff231b;
    --dashboard-trend-good-color: var(--main-green);
    --dashboard-chart-gradiant: #d6bafc;
    --dashboard-chart-empty-main-color: var(--zeroGrey);
    --dashboard-chart-main-color: var(--darkMode-white);
    --dashboard-chart-no-data-bg: var(--midnight);
    --dashboard-chart-no-data-text: var(--darkMode-white);
    --dashboard-pie-label-color: var(--zeroGrey);
    --dashboard-pie-number-color: var(--darkMode-white);
    --dashboard-pie-legend-active-color: var(--darkMode-white);
    --dashboard-pie-legend-inactive-color: var(--zeroGrey);
    --dashboard-pie-legend-active-shadow-color: var(--darkMode-white);
    --dashboard-pie-stroke: unset;
    --dashboard-report-title-hover-color: var(--main-green);
    --dashboard-report-title-hover-text-decoration: underline;
    --dashboard-report-icon-wrapper-color: var(--darkMode-white);
    --dashboard-report-name-color: var(--main-green);
    --dashboard-report-info-wrapper-color: var(--zeroGrey);
    --dashboard-exclude-user-define-font-size: 12px;
    --dashboard-trend-text-main-color: var(--darkMode-white);
    --dashboard-trend-text-secondary-color-default: var(--zeroGrey);
    --dashboard-trend-text-no-trend-color: var(--zeroGrey);
    --dashboard-trend-text-trend-up-color: var(--main-green);
    --dashboard-bar-chart-by-color-2: rgba(0, 112, 255, 1);
    --dashboard-bar-chart-by-color-1: rgba(112, 232, 250, 1);
    --dashboard-bar-chart-by-color-hover-2: rgba(0, 112, 255, 0.8);
    --dashboard-bar-chart-by-color-hover-1: rgba(111, 232, 250, 0.8);
    --dashboard-horizontal-bar-date-label: var(--darkMode-white);
    --dashboard-previous-period-color: var(--white-600);
    --dashboard-lastyear-period-color: var(--white-300);
    --dashboard-prediction-color: var(--zeroGrey);
    --dashboard-target-level-title: var(--zeroGrey);
    --dashboard-target-level-selected-period-text: var(--zeroGrey);
    --dashboard-target-level-VS-text: var(--darkMode-white);
    --dashboard-target-level-previous-period: var(--darkMode-white);
    --dashboard-security-score-empty: var(--white-500);
    --dashboard-security-score-not-empty: var(--zeroGrey);
    --dashboard-period-type-bg: var(--dark-turkiz);
    --dashboard-period-type-border-color: var(--white-250);
    --dashboard-period-type-toggle-bg: var(--main-green);
    --dashboard-period-type-toggle-bg-hover: var(--white);
    --dashboard-period-item-color: var(--main-green);
    --dashboard-period-switch-button-color: var(--white-500);
    --dashboard-period-title-color: var(--dark-turkiz);
    --dashboard-period-title-color-not-active: var(--darkMode-white);
    --dashboard-toggle-exclude-user-defined-switch-color: var(--dark-turkiz);
    --dashboard-toggle-exclude-user-defined-switch-bg: var(--codet-gray);
    --dashboard-toggle-exclude-user-defined-switch-track: var(--codet-gray);
    --dashboard-tag-cloud-color: var(--darkMode-white);
    --dashboard-monitored-asset-type-count-color: var(--main-green);
    --dashboard-close-dashboard-bg-hover: var(--dark-turkiz);
    --dashboard-close-dashboard-bg: var(--main-green);
    --dashboard-close-dashboard-color: var(--dark-turkiz);
    --dashboard-close-dashboard-color-hover: var(--main-green);
    --dashboard-yearly-generated-by-severity-legend-name: var(--zeroGrey);
    --dashboard-selected-pie-info-font-size: 12px;
    --dashboard-recent-reports-meta-data-font-color: var(--silver);

    --button-filled-bg-color: var(--main-green);
    --button-filled-color: var(--mainDarkGreen);
    --button-filled-hover-color: var(--mainGreen);
    --button-filled-hover-bg-color: var(--mainDarkGreen);
    --button-filled-disabled-color: var(--darkMode-white);
    --button-filled-disabled-bg-color: var(--secondaryGrey);
  }

  .legacy-dashboard {
    --app-bg: var(--white);
    --alert-type-color-1: var(--oxfordBlue);
    --alert-type-color-2: var(--saintPatrickBlue);
    --alert-type-color-3: var(--violetBlue);
    --alert-type-color-4: var(--ube);
    --alert-type-color-5: var(--pastelBlue);
    --alert-type-color-6: var(--languidLavender);
    --dashboard-box-radius: 5px;
    --dashboard-box-bg: var(--white);
    --dashboard-main-font-color: var(--darkJungleGreen);
    --dashboard-secondary-font-color: var(--darkJungleGreen);
    --dashboard-text-transform: unset;
    --dashboard-seperator-border: var(--platinum);
    --dashboard-chip-bg: rgba(0, 0, 0, 0.08);
    --dashboard-chip-color: unset;
    --dashboard-rechart-background: var(--munsell-500);
    --dashboard-active-chart-tick: var(--darkJungleGreen);
    --dashboard-inactive-chart-tick: var(--trolleyGrey);
    --dashboard-legend-text: var(--darkJungleGreen);
    --dashboard-empty-legend-color: var(--platinum);
    --dashboard-legend-item-wrapper: unset;
    --dashboard-linkable-title: var(--royalBlue);
    --dashboard-linkable-title-hover: var(--main-green);
    --dashboard-news-item-sub-header: var(--trolleyGrey);
    --dashboard-background: var(--munsell);
    --dashboard-items-container: var(--white);
    --dashboard-active-alert-item-radius: 5px;
    --dashboard-main-section-header-bg: var(--saintPatrickBlueFake);
    --dashboard-trend-text-empty: var(--silver-500);
    --dashboard-trend-text: var(--trolleyGrey);
    --dashboard-last-discovery: var(--darkJungleGreen-600);
    --dashboard-date-time-number: unset;
    --dashboard-date-time-letter: unset;
    --dashboard-date-time-font-size: 16px;
    --dashboard-trend-text-secondary-color: var(--platinum);
    --dashboard-trend-bad-color: var(--cgRed);
    --dashboard-trend-good-color: var(--cgGreen);
    --dashboard-chart-gradiant: var(--cornflowerBlue);
    --dashboard-chart-empty-main-color: var(--silver);
    --dashboard-chart-main-color: var(--cornflowerBlue);
    --dashboard-chart-no-data-bg: var(--munsell);
    --dashboard-chart-no-data-text: var(--trolleyGrey);
    --dashboard-pie-label-color: var(--trolleyGrey);
    --dashboard-pie-number-color: var(--darkJungleGreen);
    --dashboard-pie-legend-active-color: var(--darkJungleGreen);
    --dashboard-pie-legend-inactive-color: var(--trolleyGrey);
    --dashboard-pie-legend-active-shadow-color: var(--darkJungleGreen);
    --dashboard-pie-stroke: var(--platinum);
    --dashboard-report-title-hover-color: var(--violetBlue);
    --dashboard-report-title-hover-text-decoration: unset;
    --dashboard-report-icon-wrapper-color: var(--trolleyGrey);
    --dashboard-report-name-color: var(--royalBlue);
    --dashboard-report-info-wrapper-color: var(--trolleyGrey);
    --dashboard-exclude-user-define-font-size: 13px;
    --dashboard-trend-text-main-color: var(--cornflowerBlue);
    --dashboard-trend-text-secondary-color-default: var(--darkJungleGreen);
    --dashboard-trend-text-no-trend-color: var(--silver);
    --dashboard-trend-text-trend-up-color: var(--cgGreen);
    --dashboard-bar-chart-by-color-1: var(--violetBlue);
    --dashboard-bar-chart-by-color-2: var(--cornflowerBlue);
    --dashboard-bar-chart-by-color-hover-1: #333a6d;
    --dashboard-bar-chart-by-color-hover-2: #47599a;
    --dashboard-horizontal-bar-date-label: var(--trolleyGrey);
    --dashboard-previous-period-color: var(--trolleyGrey-650);
    --dashboard-lastyear-period-color: var(--trolleyGrey-400);
    --dashboard-prediction-color: var(--trolleyGrey);
    --dashboard-target-level-title: var(--darkJungleGreen);
    --dashboard-target-level-selected-period-text: var(--darkJungleGreen-600);
    --dashboard-target-level-VS-text: var(--trolleyGrey);
    --dashboard-target-level-previous-period: var(--trolleyGrey);
    --dashboard-security-score-empty: var(--silver);
    --dashboard-security-score-not-empty: var(--trolleyGrey);
    --dashboard-period-type-bg: var(--white);
    --dashboard-period-type-border-color: var(--darkJungleGreen-250);
    --dashboard-period-type-toggle-bg: var(--cornflowerBlue);
    --dashboard-period-type-toggle-bg-hover: var(--violetBlue);
    --dashboard-period-item-color: var(--darkJungleGreen);
    --dashboard-period-switch-button-color: var(--darkJungleGreen-600);
    --dashboard-period-title-color: var(--white);
    --dashboard-period-title-color-not-active: var(--darkJungleGreen-600);
    --dashboard-toggle-exclude-user-defined-switch-color: var(--white);
    --dashboard-toggle-exclude-user-defined-switch-bg: unset;
    --dashboard-toggle-exclude-user-defined-switch-track: var(--trolleyGrey);
    --dashboard-tag-cloud-color: var(--trolleyGrey);
    --dashboard-monitored-asset-type-count-color: var(--violetBlue);
    --dashboard-close-dashboard-bg-hover: var(--violetBlue);
    --dashboard-close-dashboard-bg: var(--royalBlue);
    --dashboard-close-dashboard-color: var(--white);
    --dashboard-close-dashboard-color-hover: var(--white);
    --dashboard-yearly-generated-by-severity-legend-name: rgba(121, 119, 119, 1);
    --dashboard-selected-pie-info-font-size: 14px;
    --dashboard-recent-reports-meta-data-font-color: (--trolleyGrey);

    --button-filled-bg-color: var(--royalBlue);
    --button-filled-color: var(--white);
    --button-filled-hover-color: var(--white);
    --button-filled-hover-bg-color: var(--violetBlue);

    --button-filled-disabled-color: var(--white-800);
    --button-filled-disabled-bg-color: var(--royalBlue-400);

    --button-radius: 5px;
  }

  .alert-center {
    --dashboard-box-radius: var(--main-border-radius);
    --dashboard-box-bg: var(--white-950);
  }
`;
